export const LIST_PAGE_SIZE = 10;

export type ListQuery = {
  q?: string;
  clienteId?: number;
  sucursalId?: number;
  page?: number;
  pageSize?: number;
};

export type PagedResult<T> = {
  data: T[];
  page: number;
  pageSize: number;
  hasMore: boolean;
  totalCount?: number;
};

export function normalizePagedResult<T>(raw: any): PagedResult<T> {
  return {
    data: (raw?.data ?? raw?.Data ?? []) as T[],
    page: raw?.page ?? raw?.Page ?? 1,
    pageSize: raw?.pageSize ?? raw?.PageSize ?? LIST_PAGE_SIZE,
    hasMore: Boolean(raw?.hasMore ?? raw?.HasMore ?? false),
    totalCount: raw?.totalCount ?? raw?.TotalCount,
  };
}

export function toListQuery(filters: Record<string, any>): ListQuery {
  const rawQ = typeof filters.q === 'string' ? filters.q.trim() : '';
  const clienteId =
    filters.cliente !== '' && filters.cliente != null ? Number(filters.cliente) : undefined;
  const sucursalId =
    filters.sucursal !== '' && filters.sucursal != null ? Number(filters.sucursal) : undefined;
  return {
    q: rawQ.length >= 3 ? rawQ : undefined,
    clienteId: Number.isFinite(clienteId) ? clienteId : undefined,
    sucursalId: Number.isFinite(sucursalId) ? sucursalId : undefined,
  };
}

export function hasActiveListFilters(filters: Record<string, any>): boolean {
  return Object.values(filters).some(
    (value) => value !== '' && value !== null && value !== undefined,
  );
}

export function hasClienteFilter(filters: Record<string, any>): boolean {
  const id = filters.cliente !== '' && filters.cliente != null ? Number(filters.cliente) : NaN;
  return Number.isFinite(id);
}

export function isAbortError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    'name' in error &&
    (error as { name: string }).name === 'AbortError'
  );
}
